import { FormattedMessage } from 'react-intl';

export function IntlSpace() {
  return <FormattedMessage defaultMessage=" " id="+Q3dd+" />;
}
